export enum NewOpportunityLoadingState {
    loadingOpportunity = 'ObservationPage.LoadingPage',
    submitting = 'Submitting Opportunity',
    uploadingFiles = 'ObservationPage.UploadingFiles'
}